import { render, staticRenderFns } from "./processes.vue?vue&type=template&id=17087de4&scoped=true&"
import script from "./processes.vue?vue&type=script&lang=js&"
export * from "./processes.vue?vue&type=script&lang=js&"
import style0 from "./processes.vue?vue&type=style&index=0&id=17087de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17087de4",
  null
  
)

export default component.exports